import styled from "styled-components";
import { FlexMixin, FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
export const ListMap = styled.div.withConfig({
    displayName: "styled__ListMap",
    componentId: "sc-b8f3ad67-0"
})`
	${FlexMixin()}
	margin-bottom: 22px;
	@media (max-width: 1350px) {
		border-left: 1px solid ${({ theme  })=>theme.colors.grays.light};
		${FlexMixin({
    direction: 'column'
})}
		padding-left: 60px;
		width: calc(100% - 322px);
	}
	@media (max-width: 1160px) {
		padding-left: 32px;
		width: calc(100% - 300px);
	}

	@media (max-width: 1100px) {
		border-left: 0;
		padding-left: 0;
		align-items: center;
		width: 100%;
	}
`;
export const MapCoasts = styled.div.withConfig({
    displayName: "styled__MapCoasts",
    componentId: "sc-b8f3ad67-1"
})`
	height: auto;
	position: relative;
	width: 740px;
	${({ $language  })=>$language === 'it' ? 'width: initial;' : 'width: 740px'}

	@media (max-width: 1351px) {
		width: 740px;
	}
`;
export const Content = styled.div.withConfig({
    displayName: "styled__Content",
    componentId: "sc-b8f3ad67-2"
})`
	margin-right: 12px;
	width: calc(100% - 752px);
	@media (max-width: 1350px) {
		width: initial;
		margin-right: 0;
	}
	@media (max-width: 1100px) {
		width: 100%;
	}
`;
export const Group = styled.div.withConfig({
    displayName: "styled__Group",
    componentId: "sc-b8f3ad67-3"
})``;
export const Title = styled.p.withConfig({
    displayName: "styled__Title",
    componentId: "sc-b8f3ad67-4"
})`
	${FontMixin({
    size: 'large',
    height: 'base',
    weight: 'regular'
})}
	color: ${({ theme  })=>theme.colors.status.info};
	margin-bottom: 20px;
`;
export const ColumnList = styled.ul.withConfig({
    displayName: "styled__ColumnList",
    componentId: "sc-b8f3ad67-5"
})`
	column-count: 4;
	column-gap: 12px;
	margin-bottom: 20px;

	div {
		position: absolute;
	}

	@media (max-width: 1100px) {
		column-count: 6;
	}
`;
export const ColumnItem = styled.li.withConfig({
    displayName: "styled__ColumnItem",
    componentId: "sc-b8f3ad67-6"
})``;
export const Link = styled.a.withConfig({
    displayName: "styled__Link",
    componentId: "sc-b8f3ad67-7"
})`
	display: block;
	color: ${({ theme  })=>theme.colors.grays.darker};
	${FontMixin({
    size: 'medium',
    weight: 'light',
    height: 'large'
})}
	width: 160px;
	margin-bottom: 10px;
	@media (max-width: 1450px) {
		width: 100px;
	}
`;

//# sourceMappingURL=styled.js.map